import { useEffect, useState } from 'react';
import NewsItem from './NewsItem';
import { Grid } from 'antd';
import { getPublicNews, NewsItem as NewsItemType } from '../../../api/services/newsService';
import NewsDetailModal from '../../../components/modals/NewsDetailModal';
import { List } from 'antd';

type NewsProps = {
  t: (key: string) => string;
};

const News = ({ t }: NewsProps) => {
  const [selectedNews, setSelectedNews] = useState<NewsItemType | null>(null);
  const [modalVisible, setModalVisible] = useState(false);

  const [newsItems, setNewsItems] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [total, setTotal] = useState<number>(0);

  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const pageSize = screens.lg ? 3 : screens.md || screens.sm ? 2 : 3;

  const handleNewsClick = (news: NewsItemType) => {
    setSelectedNews(news);
    setModalVisible(true);
  };

  const handleCloseModal = () => {
    setModalVisible(false);
    setSelectedNews(null);
  };

  const getNewsWrapper = async (page: number, pageSizeParam = pageSize) => {
    try {
      const res = await getPublicNews(page, pageSizeParam);

      setNewsItems(res.data);
      setTotal(res.total);
    } catch (error: any) {
      console.warn('Failed to load public news:', error);
    }
  };

  const handlePageChange = (page: number, _pageSize: number) => {
    setCurrentPage(page);
    getNewsWrapper(page, pageSize);
  };

  useEffect(() => {
    getNewsWrapper(currentPage, pageSize);
  }, [pageSize]);

  const fallbackNews: any[] = [
    {
      id: -1,
      title: 'Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet lorem ipsum dolor sit amet',
      summary:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et',
      preview: undefined,
    },
    {
      id: -2,
      title: 'Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet lorem ipsum dolor sit amet',
      summary:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et',
      preview: undefined,
    },
    {
      id: -3,
      title: 'Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet lorem ipsum dolor sit amet',
      summary:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et',
      preview: undefined,
    },
  ];

  return (
    <div className="section mx-10">
      <h1 className="section-title">{t('NewsTitle')}</h1>

      <List
        grid={{ gutter: 16, column: 3, xs: 1, sm: 2, md: 2, lg: 3 }}
        dataSource={newsItems.length > 0 ? newsItems : fallbackNews}
        pagination={{
          position: 'bottom',
          align: 'start',
          pageSize: pageSize,
          current: currentPage,
          onChange: handlePageChange,
          total: total,
        }}
        renderItem={(item: NewsItemType) => (
          <List.Item className="h-full">
            <NewsItem
              key={item.id}
              title={item.title}
              description={item.summary}
              actionText={t('NewsItemReadMore')}
              thumbUrl={item.preview}
              action={() => handleNewsClick(item)}
            />
          </List.Item>
        )}
      />
      <NewsDetailModal visible={modalVisible} onClose={handleCloseModal} news={selectedNews} />
    </div>
  );
};

export default News;
